export default "__VITE_ASSET__qYd08Ttf__"